// Cantidad editable de una línea del detalle de venta / pedido
// (`docs/detalle-venta-cantidad-editable-spec.md`).
//
// Solo valida lo que escribe el operador. El precio lo sigue cotizando el
// backend y el payload sigue llevando únicamente la cantidad.

export const CANTIDAD_MINIMA = 1;
export const CANTIDAD_MAXIMA = 9999;

// Un lector de código de barras tipea 8 dígitos o más (EAN-8, EAN-13, UPC).
const DIGITOS_CODIGO_BARRAS = 8;

export const MENSAJES_CANTIDAD = {
  formato: 'La cantidad debe ser un número entero entre 1 y 9.999.',
  codigo_barras: 'Eso parece un código de barras. Para cargar un producto, escaneá con el cursor en el campo Código.',
  granel: 'El peso de un artículo a granel no se cambia: quitalo y volvé a pesarlo.'
};

export function pareceCodigoDeBarras(texto) {
  const limpio = String(texto ?? '').trim();
  return new RegExp(`^\\d{${DIGITOS_CODIGO_BARRAS},}$`).test(limpio);
}

// RF-4. Devuelve `{ ok: true, cantidad }` o `{ ok: false, motivo, mensaje }`.
export function validarCantidadEscrita(texto) {
  const limpio = String(texto ?? '').trim();
  if (pareceCodigoDeBarras(limpio)) {
    return { ok: false, motivo: 'codigo_barras', mensaje: MENSAJES_CANTIDAD.codigo_barras };
  }
  if (!/^\d+$/.test(limpio)) {
    return { ok: false, motivo: 'formato', mensaje: MENSAJES_CANTIDAD.formato };
  }
  const cantidad = Number(limpio);
  if (cantidad < CANTIDAD_MINIMA || cantidad > CANTIDAD_MAXIMA) {
    return { ok: false, motivo: 'formato', mensaje: MENSAJES_CANTIDAD.formato };
  }
  return { ok: true, cantidad };
}

// RF-6. El granel es un peso de balanza: su cantidad no se edita a mano.
export function lineaConCantidadEditable(linea) {
  return Boolean(linea) && !linea.es_granel;
}

// RF-1. `−` no baja de 1 y `+` no pasa el tope.
export function cantidadConPaso(actual, paso) {
  const base = Number.parseInt(actual, 10) || CANTIDAD_MINIMA;
  return Math.min(CANTIDAD_MAXIMA, Math.max(CANTIDAD_MINIMA, base + paso));
}

// `detalle-venta-teclado-spec.md` RF-2. Índice que queda seleccionado tras
// `↑` (direccion -1) o `↓` (+1). Sin selección, `↑` va a la última línea y `↓`
// a la primera; en los extremos se queda. `null` si no hay líneas.
export function indiceConFlecha(actual, total, direccion) {
  if (!(total > 0)) return null;
  if (actual === null || actual === undefined || actual < 0 || actual >= total) {
    return direccion < 0 ? total - 1 : 0;
  }
  return Math.min(total - 1, Math.max(0, actual + direccion));
}
